import { Link } from "shared/components/Link";
import { AppRoute } from "../../constants";
import StateEstimation from "../../images/systemComponents/ModeCalculation.png";
import Layout from "../../components/mainPage/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Оценивание состояния
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Компонент <b>оценивание состояния</b> установившегося режима сети на базе CIM (Common Information Model) предназначен для определения наиболее вероятного состояния энергосистемы на основе измерений, полученных от различных устройств и систем, таких как SCADA NPT Expert, PMU (Phasor Measurement Units) и других источников данных.
                    </p>
                    <img
                        src={StateEstimation}
                        className="mb-4  w-100"
                        alt="Оценивание состояния"
                    />

                    <p>Основные этапы, которые включает в себя задача оценивания состояния:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Сбор данных</b>
                            <ul>
                                <li>Получение измерений от различных устройств в энергосистеме
                                </li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li"><b>Предварительная обработка данных</b>
                            <ul>
                                <li>Фильтрация и проверка данных на наличие ошибок.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Решение задачи оптимизации</b>
                            <ul>
                                <li>Использование численных методов для нахождения вектора состояния, минимизирующего целевую функцию.
                                </li>

                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Анализ результатов</b>
                            <ul>
                                <li>Оценка точности измеряемых режимных параметров.
                                </li>
                                <li>Дорасчет неизмеряемых режимных параметров.
                                </li>
                                <li>Выявление недостоверных измерений.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Использование результатов</b>
                            <ul>
                                <li>Применение полученных данных для управления режимами сети, анализа устойчивости, оптимизации и других задач.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Layout>
}